import { RequestStatus } from '@opengov/app-core/transport';
import { composeInitialState } from '@opengov/compose-app';
import { EmptyListOf } from '@opengov/compose-app/immutable';
import { List } from 'immutable';
import { ICurrentOrLegacyReport } from '@opengov/reporting-types';

import { composeStateMachine } from '../../module';
import { CurrentOrLegacyReport } from '../records';

export const CurrentOrLegacyReportInitialState = composeInitialState({
  reports: EmptyListOf(CurrentOrLegacyReport),
  loadingReports: RequestStatus()
});

export const currentOrLegacyReportState = composeStateMachine(
  'common-reports',
  CurrentOrLegacyReportInitialState,
  (compose) => ({
    loadReports: compose.payloadlessAction((state) => state.set('loadingReports', RequestStatus({ active: true }))),

    loadReportsSuccess: compose.action((state, payload: ICurrentOrLegacyReport[]) =>
      state.set('loadingReports', RequestStatus()).set('reports', List(payload.map(CurrentOrLegacyReport)))
    ),

    loadReportsError: compose.action((state, error: any) => state.set('loadingReports', RequestStatus({ error })))
  })
);

export const {
  actions: currentOrLegacyReportActions,
  actionCreators: currentOrLegacyReportActionCreators,
  reducer: currentOrLegacyReportReducer,
  selector: currentOrLegacyReportSelector
} = currentOrLegacyReportState;
